import { Props as RadioButtonProps } from '@storeblocks/radio';
import { useField } from 'formik';
import {
  stringOptionToBooleanOption,
  throwNotImplemented,
} from './radioButton.helpers';
import { FieldValue, Props, StringBooleanOption } from './radioButton.types';

export const useRadioButtonChangeHandler = ({
  name,
  variant,
  onChange,
}: Props): RadioButtonProps['onChange'] => {
  const [, , helpers] = useField<FieldValue>(name);
  return async (e, option): Promise<void> => {
    switch (variant) {
      case 'boolean': {
        const booleanOption = stringOptionToBooleanOption(
          option as StringBooleanOption,
        );
        await helpers.setValue(booleanOption.value);
        await helpers.setTouched(true);
        onChange?.(booleanOption.value);
        break;
      }
      case 'string':
      case undefined:
        await helpers.setValue(e.target.value);
        await helpers.setTouched(true);
        onChange?.(e.target.value);
        break;
      default:
        throwNotImplemented(variant);
    }
  };
};
